export type DocumentStatus =
	| 'INCOMPLETE'
	| 'COMPLETE'
	| 'COMPLETED_OUTSIDE_DEALSTACK'
	| 'PENDING'
	| 'NA';

export const DocumentStatus = {
	INCOMPLETE: 'INCOMPLETE',
	COMPLETE: 'COMPLETE',
	COMPLETED_OUTSIDE_DEALSTACK: 'COMPLETED_OUTSIDE_DEALSTACK',
	PENDING: 'PENDING',
	NA: 'NA',
} as const;

export type SignatureStatus = 'SIGNED' | 'WAITING' | 'REJECTED';

export const SignatureStatus = {
	SIGNED: 'SIGNED',
	WAITING: 'WAITING',
	REJECTED: 'REJECTED',
} as const;

export type SignatureType = 'ELECTRONIC' | 'WET_INK' | 'REVIEW';

export const SignatureType = {
	ELECTRONIC: 'ELECTRONIC',
	WET_INK: 'WET_INK',
	REVIEW: 'REVIEW',
} as const;

export type DocumentActionStatus = 'REISSUE' | 'SIGN' | 'DOWNLOAD' | 'E_SIGN';

export const DocumentActionStatus = {
	REISSUE: 'REISSUE',
	SIGN: 'SIGN',
	DOWNLOAD: 'DOWNLOAD',
	E_SIGN: 'E_SIGN',
} as const;

export const FATCA_NOTICE_FILE_NAME = 'FATCA & CRS Notice';

export enum ContractsReadinessStatus {
	NOT_READY = 'NOT_READY',
	INCORRECT_PHONE_NUMBER = 'INCORRECT_PHONE_NUMBER',
	READY = 'READY',
}
